import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Step } from '@core/models/step.model';

@Component({
  selector: 'mfp-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  @Input() currentStep = 1;
  @Input() steps: Step[] = [];

  @Output() clickedStep = new EventEmitter();

  constructor() {}

  navigateToStep(allowed: boolean, step: number, callback?: (step: number) => void): void {
    if (allowed && callback) {
      callback(step);
    }
  }
}
